import utilsProvider from '../../../providers/utils.provider';

const CAPTION_CLASS = 'm-0 mb-2 text-[11px] font-semibold uppercase tracking-wider text-gray-500';

const NOTE_CLASS = 'mt-2 mb-0 text-xs';

const ResultRow = ({ label, now, next }) => (
    <div className="grid grid-cols-[1fr_auto] items-baseline gap-4 py-1 text-sm">
        <span className="text-gray-500">{label}</span>
        <span className="tabular-nums whitespace-nowrap">
            <span className="text-gray-400">{utilsProvider.formatNumberCurrency(now)}</span>
            <span className="px-2 text-gray-400">→</span>
            <span className="font-semibold text-[#1d1d1f]">{utilsProvider.formatNumberCurrency(next)}</span>
        </span>
    </div>
);

const MarginWarning = ({ preview, authorizers }) => (
    <div className="mt-3 p-3 rounded-lg bg-[#fdf1ef]">
        <b className="block text-sm text-[#c1341a]">Isto deixa a empresa no prejuízo.</b>
        <span className="block mt-1 text-xs text-[#1d1d1f]">
            O faciliter receberia {utilsProvider.formatNumberCurrency(preview.faciliterNext)} e o cliente pagaria {utilsProvider.formatNumberCurrency(preview.customerNext)}.
            Faltam {utilsProvider.formatNumberCurrency(Math.abs(preview.companyNext))}.
        </span>
        <span className="block mt-1 text-xs text-gray-500">
            {preview.blocked
                ? `Você não pode aplicar isso sozinho. Quem autoriza é o financeiro: ${authorizers}.`
                : 'Você pode autorizar. O motivo é obrigatório e fica registrado com o seu nome.'}
        </span>
    </div>
);

export default function AdjustmentPreviewPanel({ preview, authorizers }) {

    return (
        <div className="mt-5 p-4 rounded-xl bg-[#f5f7fa]">
            <p className={CAPTION_CLASS}>Depois de aplicar</p>

            {preview.customerDelta !== 0 && (
                <ResultRow label="O cliente paga" now={preview.customerNow} next={preview.customerNext} />
            )}

            <ResultRow label="O faciliter recebe" now={preview.faciliterNow} next={preview.faciliterNext} />

            {preview.customerDelta !== 0 && (
                <p className={[NOTE_CLASS, 'text-gray-500'].join(' ')}>Sai do saldo do pacote do cliente.</p>
            )}

            {preview.neutralizedByReplacement && (
                <p className={[NOTE_CLASS, 'text-[#8a6100]'].join(' ')}>
                    {preview.replacementLabel} está valendo e substitui o total do faciliter, então o que está marcado
                    não vai compor o valor dele enquanto isso não mudar.
                </p>
            )}

            {preview.invertsMargin && <MarginWarning preview={preview} authorizers={authorizers} />}
        </div>
    );
}
